var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-form',{staticClass:"crud form",attrs:{"form":_vm.form,"store":_vm.store,"id":_vm.id,"edit":_vm.edit,"entity":_vm.entity,"title":_vm.title,"search":"name","submit":_vm.beforeSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }